import TagManager from "react-gtm-module";

export const sendGoogleEvent = ({ category, action, label }) => {
  const data = {
    dataLayer: {
      event: "analyticsEvent",
      category: category,
      action: action,
      label: label
    }
  };
  TagManager.dataLayer(data);
};

export const sendVirtualPageView = (url) => {
  const data = {
    dataLayer: {
      event: "virtualPageView",
      virtualPageURL: url
    }
  };

  TagManager.dataLayer(data);
};

export const sendBusinessId = (id) => {
  const data = {
    dataLayer: {
      event: "currentBusinessId",
      businessId: id
    }
  };

  TagManager.dataLayer(data);
};


export default {
  sendGoogleEvent,
  sendVirtualPageView,
  sendBusinessId
};
